import * as React from "react";
const SvgStatuCercle = (props) => /* @__PURE__ */ React.createElement("svg", { id: "b", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 53 53", height: "1em", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M26.5,51c-13.51,0-24.5-10.99-24.5-24.5S12.99,2,26.5,2s24.5,10.99,24.5,24.5-10.99,24.5-24.5,24.5Z", style: {
  fill: "currentColor",
  strokeWidth: 0
} }), /* @__PURE__ */ React.createElement("path", { d: "M26.5,4c12.41,0,22.5,10.09,22.5,22.5s-10.09,22.5-22.5,22.5S4,38.91,4,26.5,14.09,4,26.5,4M26.5,0C11.86,0,0,11.86,0,26.5s11.86,26.5,26.5,26.5,26.5-11.86,26.5-26.5S41.14,0,26.5,0h0Z", style: {
  fill: "#fff",
  strokeWidth: 0
} }));
export default SvgStatuCercle;
